import React from 'react';
import classNames from 'classnames';
import { DashboardChartT } from 'business/definitions';
import PngExportModalProvider from 'components/ExportMenu/context/PngExportModal/PngExportModalProvider';
import GridChart from '../../GridChart/GridChart';
import ChartActions from '../../ChartActions/ChartActions';
import PresentationModeContext from '../../PresentationModeContext';
// TODO This component should be refactored to work like other widgets
export type DashboardChartWidgetProps = {
    chart: DashboardChartT;
    editMode: boolean;
    canEdit: boolean;
    isPdfModeActivated: boolean;
    isCommentExpanded: boolean;
    toggleExpand: () => void;
    toggleEditMode: () => void;
};

export default function ChartWidget({
    chart,
    isCommentExpanded,
    toggleExpand,
    editMode,
    toggleEditMode,
    canEdit,
    isPdfModeActivated,
}: DashboardChartWidgetProps): React.ReactElement {
    // Do not use a div for components embedded in RGLWrapper otherwise, it won't work !
    // Root element must be a react component.
    const chartActions = React.useMemo(
        () =>
            isPdfModeActivated ? (
                <></>
            ) : (
                <ChartActions
                    toggleExpand={toggleExpand}
                    isExpanded={isCommentExpanded}
                    canEdit={canEdit}
                    chartKey={chart.key}
                />
            ),
        [
            toggleExpand,
            isCommentExpanded,
            canEdit,
            chart.key,
            isPdfModeActivated,
        ],
    );
    return (
        <PngExportModalProvider>
            <GridChart
                chart={chart}
                className={classNames({
                    'editable-grid': editMode && !isPdfModeActivated,
                })}
                canEdit={canEdit}
                hideLink={editMode || Boolean(chart.settings.isMedia)}
                title={chart.title}
                editMode={editMode}
                toggleEditMode={toggleEditMode}
                isPdfModeActivated={isPdfModeActivated}
            >
                <PresentationModeContext.Consumer>
                    {([presentationMode]) => !presentationMode && chartActions}
                </PresentationModeContext.Consumer>
            </GridChart>
        </PngExportModalProvider>
    );
}
